__turbopack_context__.v({
  "cardAnimation": "VgrSFq_cardAnimation",
  "fadeInUp": "VgrSFq_fadeInUp",
  "headerAnimation": "VgrSFq_headerAnimation",
  "sectionAnimation": "VgrSFq_sectionAnimation",
});
